import { Text } from '@mantine/core'
import type { ReactNode } from 'react'
import { colors } from 'settings/colors'

export const MapCardTitle = ({ title, titleIcons }: { title: string; titleIcons?: ReactNode }) => (
  <Text c={colors.midnight} fw={700} fz="18px">
    {title}
    {titleIcons && (
      // zero width, so the icons hang after the last word and never change how the title wraps,
      // and as tall as the letters from their top, so the icons center on the letters
      <span
        css={{
          position: 'relative',
          display: 'inline-block',
          width: 0,
          height: '1.2em',
          verticalAlign: 'text-top',
        }}
      >
        <span
          css={{
            position: 'absolute',
            top: '50%',
            left: 0,
            display: 'flex',
            marginLeft: 8,
            transform: 'translateY(-50%)',
          }}
        >
          {titleIcons}
        </span>
      </span>
    )}
  </Text>
)
